import { render } from "./BrandTable.vue?vue&type=template&id=65e764cf&scoped=true"
import script from "./BrandTable.vue?vue&type=script&lang=js"
export * from "./BrandTable.vue?vue&type=script&lang=js"

import "./BrandTable.vue?vue&type=style&index=0&id=65e764cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e764cf"]])

export default __exports__